module.exports = __webpack_public_path__ + "img/c355a64d-33ed-4ecd-987d-8702c28c5e23.aef15605.png";